export default "__VITE_ASSET__D$_Qob8C__"